module.exports = __webpack_public_path__ + "static/assets/b002e7fb3cade0f9568f35feca06a9cb.png";